import Icon from '@ant-design/icons';

export default function DashboardIcons(props) {
   return (
      <Icon
         component={() => (
            <svg width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
               <path d="M2.31686 18C1.66334 18 1.11381 17.7772 0.668275 17.3317C0.222758 16.8862 0 16.3367 0 15.6831V2.31686C0 1.66334 0.222758 1.11381 0.668275 0.668275C1.11381 0.222758 1.66334 0 2.31686 0H15.6831C16.3367 0 16.8862 0.222758 17.3317 0.668275C17.7772 1.11381 18 1.66334 18 2.31686V15.6831C18 16.3367 17.7772 16.8862 17.3317 17.3317C16.8862 17.7772 16.3367 18 15.6831 18H2.31686ZM2.31686 16.3125H8.15625V1.6875H2.31686C2.15953 1.6875 2.0153 1.75306 1.88417 1.88417C1.75306 2.0153 1.6875 2.15953 1.6875 2.31686V15.6831C1.6875 15.8405 1.75306 15.9847 1.88417 16.1158C2.0153 16.2469 2.15953 16.3125 2.31686 16.3125ZM9.84375 16.3125H15.6831C15.8405 16.3125 15.9847 16.2469 16.1158 16.1158C16.2469 15.9847 16.3125 15.8405 16.3125 15.6831V9H9.84375V16.3125ZM9.84375 7.3125H16.3125V2.31686C16.3125 2.15953 16.2469 2.0153 16.1158 1.88417C15.9847 1.75306 15.8405 1.6875 15.6831 1.6875H9.84375V7.3125Z" />
            </svg>
         )}
         {...props}
      />
   );
}
